import axios from "axios";
import { Toast } from "vant";
import appStore from "../store/modules/app";
import { getCountry } from "@/utils/common.js";

const domainApiMaps = {
  china: [
    {
      host: "speedbiz-h5.cn.gtech.asia",
      apiUrl: "https://speedbiz-api.cn.gtech.asia",
      apiUrlOp: "https://speedbiz-operation-api.cn.gtech.asia",
      siteUrl: "https://speedbiz-h5.cn.gtech.asia",
      b2bcashSiteUrl: "https://m.speedwork.shop",
      b2bpointsSiteUrl: "https://b2bshop.speedwork.cn",
      wintogetherSiteUrl: "https://wtcn-h5.cn.gtech.asia"
    },
    {
      host: "speedbiz-h5-new.cn.gtech.asia",
      apiUrl: "https://speedbiz-api.cn.gtech.asia",
      apiUrlOp: "https://speedbiz-operation-api.cn.gtech.asia",
      siteUrl: "https://speedbiz-h5-new.cn.gtech.asia",
      b2bcashSiteUrl: "https://m-new.speedwork.shop",
      b2bpointsSiteUrl: "https://b2bshop-new.speedwork.cn",
      wintogetherSiteUrl: "https://wtcn-h5-new.cn.gtech.asia"
    },
    {
      host: "speedbiz-h5-test.gtech.asia",
      apiUrl: "https://speedbiz-api-test.gtech.asia",
      apiUrlOp: "https://speedbiz-operation-api-test.gtech.asia",
      siteUrl: "https://speedbiz-h5-test.gtech.asia",
      b2bcashSiteUrl: "http://speedb2b-h5-test.gtech.asia",
      b2bpointsSiteUrl: "https://b2b-test.gtech.asia",
      wintogetherSiteUrl: "https://wintogether-china-h5-test.gtech.asia"
    },
    {
      host: "speedbiz-h5-dev.gtech.asia",
      apiUrl: "https://speedbiz-api-dev.gtech.asia",
      apiUrlOp: "https://speedbiz-operation-api-dev.gtech.asia",
      siteUrl: "https://speedbiz-h5-dev.gtech.asia",
      b2bcashSiteUrl: "https://speedb2b-h5-dev.gtech.asia",
      b2bpointsSiteUrl: "https://b2b-dev.gtech.asia",
      wintogetherSiteUrl: "http://wintogether-china-h5-dev.gtech.asia"
    },
    {
      host: "speedbiz-h5-test.gtechcloud.cn",
      apiUrl: "https://speedbiz-api-test.gtechcloud.cn",
      apiUrlOp: "https://speedbiz-operation-api-test.gtechcloud.cn",
      siteUrl: "https://speedbiz-h5-test.gtechcloud.cn",
      b2bcashSiteUrl: "http://speedb2b-h5-test.gtech.asia",
      b2bpointsSiteUrl: "https://b2b-test.gtech.asia",
      wintogetherSiteUrl: "https://wintogether-china-h5-test.gtech.asia"
    }
  ],
  my: [
    {
      host: "speedbiz-h5.my.gtech.asia",
      apiUrl: "https://speedbiz-api.my.gtech.asia",
      apiUrlOp: "https://speedbiz-operation-api.my.gtech.asia",
      siteUrl: "https://speedbiz-h5.my.gtech.asia"
    },
    {
      host: "speedbiz-h5-my-test.gtech.asia",
      apiUrl: "https://speedbiz-my-api-test.gtech.asia",
      apiUrlOp: "https://speedbiz-operation-my-api-test.gtech.asia",
      siteUrl: "https://speedbiz-h5-my-test.gtech.asia"
    },
    {
      host: "speedbiz-h5-my-dev.gtech.asia",
      apiUrl: "https://speedbiz-my-api-dev.gtech.asia",
      apiUrlOp: "https://speedbiz-operation-my-api-dev.gtech.asia",
      siteUrl: "https://speedbiz-h5-my-dev.gtech.asia"
    }
  ]
};

const devDomainMaps = {
  host: window.location.host,
  apiUrl: `${window.location.origin}/api`,
  apiUrlOp: `${window.location.origin}/opapi`,
  siteUrl: `${window.location.origin}`,
  b2bcashSiteUrl: "https://speedb2b-h5-dev.gtech.asia",
  b2bpointsSiteUrl: "https://b2b-dev.gtech.asia",
  wintogetherSiteUrl: "http://wintogether-china-h5-dev.gtech.asia"
};

/**
 * 创建axios实例
 * @param {*} appName speedbiz | speedbiz-operation
 * @returns axios实例
 */
function createAxios(apiUrl) {
  const service = axios.create({
    baseURL: apiUrl, // api的base_url
    timeout: 15000 // 请求超时时间,
  });
  // request拦截器
  service.interceptors.request.use(
    config => {
      if (window.localStorage.authtoken && window.localStorage.authtoken !== "undefined") {
        config.headers["userAuthToken"] = window.localStorage.authtoken;
      }
      config.headers["userLanguage"] = appStore.state.lang;
      config.headers["clientType"] = "H5";
      return config;
    },
    error => {
      Promise.reject(error);
    }
  );

  // respone拦截器
  service.interceptors.response.use(
    response => {
      /**
       * code为非0是抛错 结合业务进行修改
       */
      const res = response.data;
      if (res.code !== "0") {
        if (response.config.options.errorMessage) {
          Toast(res.message);
        }
        if (res.code === "speedbiz.error-user-auth-token" || res.code === "speedbiz.empty-user-auth-token") {
          //
        }
        return Promise.reject(res);
      }
      return res;
    },
    error => {
      // 错误处理
      try {
        switch (error.response.status) {
          case 500:
            error.message = window._I18N.t("axios.server-exception"); // 明确返回500
            break;
          case 404:
            error.message = window._I18N.t("axios.server-Address-404"); // 明确返回404
            break;
          default:
            error.message = window._I18N.t("axios.Unknown-error-occurred"); // 其他错误code
        }
      } catch (e) {
        error.message = window._I18N.t("axios.Network-congestion"); // 超时 获取不到status
      }
      if (error.config.options.errorMessage) {
        Toast(error.message);
      }
      return Promise.reject(error);
    }
  );
  return service;
}

const verifySign = function(param) {
  const constParams = {
    timestamp: new Date().valueOf(),
    appCode: "speedbiz"
  };
  const body = param || {};
  Object.assign(body, constParams);
  return body;
};

export function uploadImg(url, file) {
  // eslint-disable-next-line quotes
  return axios.post(url, file, {
    headers: {
      "content-type": "multipart/form-data"
    }
  });
}

/**
 * 返回axios实例包装函数
 * @param {*} appName speedbiz | speedbiz-operation
 * @returns axios实例包装函数
 */
export function createHttpServer(appName) {
  const host = window.location.host;
  const country = getCountry();
  const { apiUrl, apiUrlOp, siteUrl, b2bcashSiteUrl, b2bpointsSiteUrl, wintogetherSiteUrl } =
    process.env.NODE_ENV === "production" ? domainApiMaps[country].find(item => item.host === host) : devDomainMaps;
  window.SITE_URL = siteUrl;
  window.B2B_CASH_SITE_URL = b2bcashSiteUrl;
  window.B2B_POINTS_SITE_URL = b2bpointsSiteUrl;
  window.WINTOGETHER_SITE_URL = wintogetherSiteUrl;

  const url = appName === "speedbiz" ? apiUrl : apiUrlOp;
  const service = createAxios(url);

  return function(url, params, options = { errorMessage: true }) {
    return service({
      url: url,
      method: "post",
      data: verifySign(params),
      options: options
    });
  };
}



// WEBPACK FOOTER //
// ./src/api/axios.js